<template>
  <div class="animated fadeIn">
    <b-row class="mt-2">
      <b-col>
        <h2>ข้อมูลบริษัทของท่าน</h2>
      </b-col>
      <b-col>
        <b-button v-if="profileUrl" class="float-right ml-4" variant="success" target="_blank" :to="{name: 'โปรไฟล์', params: {companyUrl:profileUrl}}">ดูตัวอย่างโปรไฟล์</b-button>
        <b-button class="float-right ml-4" variant="primary" @click="save(false)">บันทึก</b-button>
        <b-button class="float-right ml-4" @click="save(true)">บันทึกร่าง</b-button>
        <b-button class="float-right" @click="goBack" variant="warning">ย้อนกลับ</b-button>
        <br />
      </b-col>
    </b-row>
    <b-row v-if="carrierStatus !== 1">
      <b-col>
        <b-alert show variant="warning">กรุณากรอกข้อมูลให้ครบถ้วนพร้อมกดบันทึก และรอการยืนยันตัวตนจากเจ้าหน้าที่ภายใน 1-2 วัน หรือติดต่อเจ้าหน้าที่ <b-link :to="{name: 'ติดต่อเรา'}">ที่นี่</b-link></b-alert>
      </b-col>
    </b-row>
    <b-row v-if="form.saveDraft">
      <b-col>
        <b-alert show variant="danger">บันทึกร่างสำเร็จ หากคุณแก้ไขข้อมูลเสร็จสิ้น กรุณากดปุ่ม "บันทึก" เพื่อทำการบันทึกข้อมูลเข้าสู่ระบบ</b-alert>
      </b-col>
    </b-row>
    <b-row v-if="loadOk">
      <b-col sm="12" md="6">
        <b-card>
          <div slot="header">
            <strong>โลโก้</strong>
          </div>
          <DocLogo docType="update-profile-logo" v-bind:preventDelete="false" />
          <UploadDoc
            docType="update-profile-logo"
            v-bind:acceptedFiles="'image/jpeg,image/png'"
            :forLogo="true"
          />
        </b-card>
      </b-col>
    </b-row>
    <b-form>
      <b-row>
        <b-col md="12" lg="12">
          <b-card>
            <div slot="header">
              <strong>ส่วนที่ 1 : ข้อมูลทั่วไป</strong>
            </div>
            <b-row>
              <b-col class="my-3" sm="12">
                <h5>ข้อมูลธุรกิจ</h5>
              </b-col>
              <b-col md="6">
                <TextInput
                  :value="$v.form.companyName"
                  id="companyName"
                  feedback="จำเป็นต้องระบุ"
                  label="ชื่อบริษัท"
                  placeholder="ตัวอย่าง: ร่ำรวยขนส่ง"
                  :isRequired="true"
                />
              </b-col>
              <b-col md="6">
                <SelectInput
                  :value="$v.form.companyType"
                  id="companyType"
                  feedback="เลือกประเภท"
                  label="ประเภทบริษัท"
                  :options="companyTypeOptions"
                  :isRequired="true"
                />
              </b-col>
              <b-col md="6">
                <TextInput
                  :value="$v.form.nid"
                  id="nid"
                  feedback="ระบุเลขทะเบียนนิติบุคคล"
                  label="เลขทะเบียนนิติบุคคล"
                  placeholder
                  :isRequired="true"
                />
              </b-col>
              <b-col md="6">
                <TextInput
                  :value="$v.form.address"
                  id="address"
                  feedback="ระบุที่อยู่"
                  label="ที่อยู่"
                  placeholder
                  :isRequired="true"
                />
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="companyHQProvince">
                    ที่ตั้งสำนักงานใหญ่
                    <span class="text-danger">*</span>
                  </label>
                  <b-form-select
                    v-model="$v.form.companyHQProvince.$model"
                    id="companyHQProvince"
                    :state="$v.form.companyHQProvince.$dirty ? !$v.form.companyHQProvince.$error : null"
                    aria-describedby="companyHQProvince-live-feedback"
                  >
                    <option
                      v-for="option in provinceOptions"
                      v-bind:value="option.name"
                      v-bind:key="option.name"
                    >{{ option.name }}</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="companyHQProvince-live-feedback">เลือกจังหวัด</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <TextInput
                  :value="$v.form.website"
                  id="website"
                  feedback="ระบุเว็บไซต์"
                  label="เว็บไซต์"
                />
              </b-col>
              <b-col md="6">
                <TextInput
                  :value="$v.foundingYear"
                  id="foundingYear"
                  feedback="ระบุปี"
                  label="ปีที่ก่อตั้ง (พ.ศ.)"
                  :isRequired="true"
                />
              </b-col>
              <b-col md="6">
                <TextInput
                  :value="$v.form.employeeNum"
                  id="employeeNum"
                  feedback="ระบุตัวเลข"
                  label="จำนวนพนักงาน"
                  :isRequired="true"
                />
              </b-col>
              <b-col md="6">
                <MultiSelectTagValidate
                  v-if="loadOk"
                  label="ลักษณะธุรกิจ"
                  v-model="$v.businessType"
                  :options="businessTypeOptions"
                  placeholder="สามารถเลือกได้หลายประเภท"
                  :isRequired="true"
                />
              </b-col>
            </b-row>
            <hr class="divider" />
            <b-row>
              <b-col class="my-3" sm="12">
                <h5>ใบอนุญาต มาตรฐาน และรางวัล</h5>
              </b-col>
              <b-col md="6">
                <MultiSelectTagValidate
                  v-if="loadOk"
                  label="ใบอนุญาตและมาตรฐาน"
                  v-model="$v.standard"
                  :options="standardOptions"
                  placeholder="สามารถเลือกได้หลายข้อและสามารถเพิ่มเติมได้"
                  :disableNewTag="false"
                />
              </b-col>
              <b-col md="6">
                <MultiSelectTagValidate
                  v-if="loadOk"
                  label="รางวัล"
                  v-model="$v.reward"
                  :options="rewardOptions"
                  placeholder="เช่น รางวัลขนส่งรักษาสิ่งแวดล้อม 2020"
                  :disableNewTag="false"
                />
              </b-col>
            </b-row>
            <hr class="divider" />
            <b-row>
              <b-col class="my-3" sm="12">
                <h5>เครือข่าย</h5>
              </b-col>
              <b-col md="6">
                <MultiSelectTagValidate
                  v-if="loadOk"
                  label="เครือข่ายสมาคม"
                  v-model="$v.network"
                  :options="networkOptions"
                  placeholder="สามารถเลือกได้หลายข้อและสามารถเพิ่มเติมได้"
                  :disableNewTag="false"
                />
              </b-col>
            </b-row>
            <hr class="divider" />
            <b-row>
              <b-col class="my-3" sm="12">
                <h5>ข้อมูลติดต่อบริษัท</h5>
              </b-col>
              <b-col md="6">
                <TextInput
                  :value="$v.form.contactPersion"
                  id="contactPersion"
                  feedback="ระบุชื่อผู้ติดต่อ"
                  label="ชื่อผู้ติดต่อ (สามารถใส่ได้หลายคน)"
                  placeholder="เช่น ฝ่ายขาย , คุณสมชาย"
                  :isRequired="true"
                />
              </b-col>
              <b-col md="6">
                <TextInput
                  :value="$v.form.tel"
                  id="tel"
                  feedback="เบอร์โทรต้องขึ้นต้อนด้วย 0 และมี 10 หลักประกอบด้วย 0-9"
                  label="เบอร์โทรผู้ติดต่อ (สามารถใส่ได้หลายคน)"
                  placeholder="เช่น 081-111-1111, 02-222-3333"
                  :isRequired="true"
                />
              </b-col>
              <b-col md="6">
                <TextInput
                  :value="$v.form.email"
                  id="email"
                  feedback="ระบุอีเมล"
                  label="อีเมล (สามารถใส่ได้หลายอีเมล)"
                  placeholder="เช่น sales@example.com, somchai@example.com"
                  :isRequired="true"
                />
              </b-col>
              <!-- <b-col md="6">
                <TextInput
                  :value="$v.form.profileUrl"
                  id="profileUrl"
                  feedback="ระบุ permalink"
                  label="Permalink"
                  :isRequired="true"
                />
              </b-col>-->
              <!-- <b-col md="6">
                <TextInput
                  :value="$v.form.registeredCapital"
                  id="registeredCapital"
                  feedback="ระบุตัวเลข"
                  label="ทุนจดทะเบียน"
                />
              </b-col>
              <b-col md="6">
                <TextInput
                  :value="$v.form.lastYearRevenue"
                  id="lastYearRevenue"
                  feedback="ระบุตัวเลข"
                  label="รายได้ปีล่าสุด"
                />
              </b-col>-->
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="showCarrier">
        <b-col md="12" lg="12">
          <b-card>
            <div slot="header">
              <strong>ส่วนที่ 2 : Carrier Profile</strong>
            </div>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <label>
                    แรงงานลงสินค้า
                    <span class="text-danger">*</span>
                  </label>
                  <b-form-radio-group
                    id="porterService"
                    v-model="$v.form.porterService.$model"
                    :options="porterServiceOptions"
                    :state="$v.form.porterService.$dirty ? !$v.form.porterService.$error : null"
                    aria-describedby="porterService-live-feedback"
                  ></b-form-radio-group>
                  <b-form-invalid-feedback id="porterService-live-feedback">กรุณาเลือก</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col md="6" class="mb-4">
                <b-form-group>
                  <label>
                    รูปแบบการรับสินค้า
                    <span class="text-danger">*</span>
                  </label>
                  <b-form-checkbox-group
                    id="typeOfCargo"
                    v-model="$v.form.typeOfCargo.$model"
                    :options="textObjToArr(typeOfCargoOptions)"
                    :state="$v.form.typeOfCargo.$dirty ? !$v.form.typeOfCargo.$error : null"
                    aria-describedby="typeOfCargo-live-feedback"
                  ></b-form-checkbox-group>
                  <b-form-invalid-feedback
                    id="typeOfCargo-live-feedback"
                    :state="$v.form.typeOfCargo.$dirty ? !$v.form.typeOfCargo.$error : null"
                  >กรุณาเลือก</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col md="6" class="mb-4">
                <MultiSelectTagValidate
                  v-if="loadOk"
                  label="พื้นที่ให้บริการ"
                  v-model="$v.serviceArea"
                  :options="serviceAreaOptions"
                  :isRequired="true"
                  placeholder="เลือกได้หลายภาค"
                />
              </b-col>
              <b-col md="6" class="mb-4">
                <MultiSelectTagValidate
                  v-if="loadOk"
                  label="ลานจอด"
                  v-model="$v.parkingBase"
                  :options="parkingBaseOptions"
                  :isRequired="true"
                  placeholder="เลือกได้หลายจังหวัด"
                />
              </b-col>
              <b-col md="6" class="mb-4">
                <!-- <MultiSelectTag
                  v-if="loadOk"
                  label="วิ่งข้ามชายแดน"
                  v-model="crossThaiBorder"
                  :options="crossThaiBorderOptions"
                />-->
                <b-form-group>
                  <label>
                    วิ่งข้ามชายแดน (เลือกได้หลายประเทศ)
                    <span class="text-danger">*</span>
                  </label>
                  <b-form-checkbox-group
                    id="crossThaiBorder"
                    stacked
                    v-model="$v.form.crossThaiBorder.$model"
                    :options="textObjToArr(crossThaiBorderOptions)"
                    :state="$v.form.crossThaiBorder.$dirty ? !$v.form.crossThaiBorder.$error : null"
                    aria-describedby="crossThaiBorder-live-feedback"
                  ></b-form-checkbox-group>
                  <b-form-invalid-feedback
                    id="crossThaiBorder-live-feedback"
                    :state="$v.form.crossThaiBorder.$dirty ? !$v.form.crossThaiBorder.$error : null"
                  >กรุณาเลือก</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col md="6" class="mb-4">
                <!-- <MultiSelectTag
                  v-if="loadOk"
                  label="ประเภทงานที่เคยรับ"
                  v-model="natureOfCargo"
                  :options="natureOfCargoOptions"
                />-->
                <b-form-group>
                  <label>
                    ประเภทงานที่เคยรับ (เลือกได้หลายประเภท)
                    <span class="text-danger">*</span>
                  </label>
                  <b-form-checkbox-group
                    id="natureOfCargo"
                    stacked
                    v-model="$v.form.natureOfCargo.$model"
                    :options="textObjToArr(natureOfCargoOptions)"
                    :state="$v.form.natureOfCargo.$dirty ? !$v.form.natureOfCargo.$error : null"
                    aria-describedby="natureOfCargo-live-feedback"
                  ></b-form-checkbox-group>
                  <b-form-invalid-feedback
                    id="natureOfCargo-live-feedback"
                    :state="$v.form.natureOfCargo.$dirty ? !$v.form.natureOfCargo.$error : null"
                  >กรุณาเลือก</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <!-- <b-col md="6">
                <MultiSelectTag v-if="loadOk" label="ระบบโหลดของ" v-model="availableLoadingSystem" />
              </b-col>
              <b-col md="6">
                <MultiSelectTag v-if="loadOk" label="อุปกรณ์บนรถ" v-model="vehicleEquipment" />
              </b-col>-->
            </b-row>
            <hr class="divider" />
            <b-row class="mt-4">
              <b-col md="6">
                <h5>
                  ประเภทรถที่มี
                </h5>
                <b-tabs content-class="mt-3" pills card>
                  <b-tab title="4 ล้อ" active>
                    <b-row>
                      <b-col>
                        <div v-for="truckType in truckTypes" v-bind:key="truckType.typeName">
                          <b-row class="mb-1" v-if="truckType.category == '4ล้อ'">
                            <b-col>
                              <label for>{{ truckType.typeName }}</label>
                            </b-col>
                            <b-col>
                              <b-input-group>
                                <b-form-input
                                  v-model="ownTruckNumByType[truckType.typeName]"
                                  type="number"
                                  min="0"
                                  placeholder
                                  @change="onTruckNumChange"
                                  :state="ownTruckTypeError == true || ownTruckTypeError == false ? (ownTruckTypeError == true ? false : (ownTruckNumByType[truckType.typeName] > 0 ? true : null)) : null"
                                ></b-form-input>
                                <b-input-group-append>
                                  <b-input-group-text>คัน</b-input-group-text>
                                </b-input-group-append>
                              </b-input-group>
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="6 ล้อ">
                    <b-row>
                      <b-col>
                        <div v-for="truckType in truckTypes" v-bind:key="truckType.typeName">
                          <b-row class="mb-1" v-if="truckType.category == '6ล้อ'">
                            <b-col>
                              <label for>{{ truckType.typeName }}</label>
                            </b-col>
                            <b-col>
                              <b-input-group>
                                <b-form-input
                                  v-model="ownTruckNumByType[truckType.typeName]"
                                  type="number"
                                  placeholder
                                  @change="onTruckNumChange"
                                  :state="ownTruckTypeError == true || ownTruckTypeError == false ? (ownTruckTypeError == true ? false : (ownTruckNumByType[truckType.typeName] > 0 ? true : null)) : null"
                                ></b-form-input>
                                <b-input-group-append>
                                  <b-input-group-text>คัน</b-input-group-text>
                                </b-input-group-append>
                              </b-input-group>
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="10 ล้อ">
                    <b-row>
                      <b-col>
                        <div v-for="truckType in truckTypes" v-bind:key="truckType.typeName">
                          <b-row class="mb-1" v-if="truckType.category == '10ล้อ'">
                            <b-col>
                              <label for>{{ truckType.typeName }}</label>
                            </b-col>
                            <b-col>
                              <b-input-group>
                                <b-form-input
                                  v-model="ownTruckNumByType[truckType.typeName]"
                                  type="number"
                                  placeholder
                                  @change="onTruckNumChange"
                                  :state="ownTruckTypeError == true || ownTruckTypeError == false ? (ownTruckTypeError == true ? false : (ownTruckNumByType[truckType.typeName] > 0 ? true : null)) : null"
                                ></b-form-input>
                                <b-input-group-append>
                                  <b-input-group-text>คัน</b-input-group-text>
                                </b-input-group-append>
                              </b-input-group>
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="รถพ่วง">
                    <b-row>
                      <b-col>
                        <div v-for="truckType in truckTypes" v-bind:key="truckType.typeName">
                          <b-row class="mb-1" v-if="truckType.category == 'รถพ่วง'">
                            <b-col>
                              <label for>{{ truckType.typeName }}</label>
                            </b-col>
                            <b-col>
                              <b-input-group>
                                <b-form-input
                                  v-model="ownTruckNumByType[truckType.typeName]"
                                  type="number"
                                  placeholder
                                  @change="onTruckNumChange"
                                  :state="ownTruckTypeError == true || ownTruckTypeError == false ? (ownTruckTypeError == true ? false : (ownTruckNumByType[truckType.typeName] > 0 ? true : null)) : null"
                                ></b-form-input>
                                <b-input-group-append>
                                  <b-input-group-text>คัน</b-input-group-text>
                                </b-input-group-append>
                              </b-input-group>
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="เทรลเลอร์">
                    <b-row>
                      <b-col>
                        <div v-for="truckType in truckTypes" v-bind:key="truckType.typeName">
                          <b-row class="mb-1" v-if="truckType.category == 'เทรลเลอร์'">
                            <b-col>
                              <label for>{{ truckType.typeName.replace('เทรลเลอร์', '') }}</label>
                            </b-col>
                            <b-col>
                              <b-input-group>
                                <b-form-input
                                  v-model="ownTruckNumByType[truckType.typeName]"
                                  type="number"
                                  placeholder
                                  @change="onTruckNumChange"
                                  :state="ownTruckTypeError == true || ownTruckTypeError == false ? (ownTruckTypeError == true ? false : (ownTruckNumByType[truckType.typeName] > 0 ? true : null)) : null"
                                ></b-form-input>
                                <b-input-group-append>
                                  <b-input-group-text>{{ truckType.typeName == 'หัวลาก' ? 'หัว' : 'หาง' }}</b-input-group-text>
                                </b-input-group-append>
                              </b-input-group>
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                    </b-row>
                  </b-tab>
                </b-tabs>
                <p
                  class="logisty-custom-invalid-feedbace"
                  v-if="ownTruckTypeError"
                >กรุณาระบุจำนวนรถที่มี</p>
              </b-col>
            </b-row>
            <hr class="divider" />
            <b-row class="mt-4">
              <b-col md="6">
                <b-row>
                  <b-col sm="12">
                    <h5>
                      งานเที่ยวกลับที่ต้องการ
                    </h5>
                    <div v-for="(item, index) in $v.backhaulRequest.$each.$iter" v-bind:key="index">
                      <b-row class="mb-1">
                        <b-col sm="6">
                          <b-form-group>
                            <label for>
                              จาก
                              <span class="text-danger">*</span>
                            </label>
                            <b-form-select
                              :id="'backhaul-from-' + index"
                              v-model.trim="item.from.$model"
                              :state="item.from.$dirty ? !item.from.$error : null"
                              :aria-describedby="'backhaul-from-' + index + '-live-feedback'"
                            >
                              <option
                                v-for="option in serviceAreaOptions"
                                v-bind:value="option.value"
                                v-bind:key="option.value"
                              >{{ option.value }}</option>
                            </b-form-select>
                            <b-form-invalid-feedback
                              :id="'backhaul-from-' + index + '-live-feedback'"
                            >เลือกภาค</b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <b-form-group>
                            <label for>
                              ไปยัง
                              <span class="text-danger">*</span>
                            </label>
                            <b-form-select
                              :id="'backhaul-to-' + index"
                              v-model.trim="item.to.$model"
                              :state="item.to.$dirty ? !item.to.$error : null"
                              :aria-describedby="'backhaul-to-' + index + '-live-feedback'"
                            >
                              <option
                                v-for="option in serviceAreaOptions"
                                v-bind:value="option.value"
                                v-bind:key="option.value"
                              >{{ option.value }}</option>
                            </b-form-select>
                            <b-form-invalid-feedback
                              :id="'backhaul-to-' + index + '-live-feedback'"
                            >เลือกภาค</b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col sm="12">
                          <MultiSelectTagValidate
                            v-if="loadOk"
                            label="ประเภทรถ"
                            v-model.trim="item.truckType"
                            :options="truckTypeProfileOptions"
                            :isRequired="true"
                            placeholder="เลือกได้หลายประเภท"
                          />
                        </b-col>
                      </b-row>
                      <b-row class="mt-2">
                        <b-col class="text-center">
                          <b-button block variant="warning" @click="removeBackhaul(index)">ลบ</b-button>
                        </b-col>
                      </b-row>
                      <hr class="divider" />
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="text-center" sm="12">
                    <b-button block variant="success" @click="appendBackhaul">เพิ่ม</b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <hr class="divider" />
            <b-row class="mt-4" v-if="loadOk">
              <b-col>
                <h5>รูปประกอบ</h5>
                <DocList docType="update-profile-showcase" refId v-bind:preventDelete="false" />
                <UploadDoc
                  ref="showcaseUpload"
                  docType="update-profile-showcase"
                  headerText="อัพโหลดรูปภาพ"
                  v-bind:acceptedFiles="'image/jpeg,image/png'"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
    <ModalLoading />
    <b-row class="mt-2 mb-2">
      <b-col>
        <p>
          เมื่อกดบันทึกข้อมูล ท่านยินยอมให้ข้อมูลทั้งหมดของท่านถูกแสดงในหน้า "ค้นหาผู้ให้บริการขนส่ง"  หากท่านไม่ต้องการให้ข้อมูลของท่านปรากฏ กรุณาติดต่อ<b-link :to="{ name: 'ติดต่อเรา' }"> ทีมงาน</b-link>
        </p>
      </b-col>
    </b-row>
    <b-row class="mt-2 mb-2">
      <b-col>
        <b-button v-if="profileUrl" class="float-right ml-4" variant="success" target="_blank" :to="{name: 'โปรไฟล์', params: {companyUrl:profileUrl}}">ดูตัวอย่างโปรไฟล์</b-button>
        <b-button class="float-right ml-4" variant="primary" @click="save(false)">บันทึก</b-button>
        <b-button class="float-right ml-4" @click="save(true)">บันทึกร่าง</b-button>
        <b-button class="float-right" @click="goBack" variant="warning">ย้อนกลับ</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import TextInput from '../../components/TextInput'
import SelectInput from '../../components/SelectInput'
import MultiSelectTag from '../../components/MultiSelectTagOld'
import MultiSelectTagValidate from '../../components/MultiSelectTagValidate'
import ModalLoading from '../../components/ModalLoading'

import Profile from '../../services/http/Profile'
import AppInfo from '../../services/http/AppInfo'
import TruckType from '../../services/http/TruckType'

import { validationMixin } from 'vuelidate'
import { required, requiredIf, email, helpers, url, numeric, decimal, between, minLength, maxLength } from 'vuelidate/lib/validators'

import DocLogo from '../../components/DocLogo'
import DocList from '../../components/DocList'
import UploadDoc from '../../components/UploadDoc'

const randomstring = require('randomstring')

export default {
  mixins: [validationMixin],
  components: {
    DocLogo,
    DocList,
    UploadDoc,
    TextInput,
    SelectInput,
    MultiSelectTag,
    ModalLoading,
    MultiSelectTagValidate
  },
  data () {
    return {
      form: {
        companyName: null,
        phoneNumber: null,
        email: null,
        companyType: null,
        profileUrl: null,
        tel: null,
        contactPersion: null,
        website: null,
        foundingYear: null,
        employeeNum: null,
        // registeredCapital: null,
        // lastYearRevenue: null,
        reward: [],
        standard: [],
        network: [],
        businessType: [],
        parkingBase: [],
        companyHQProvince: null,
        address: null,
        // carrier
        logisticServiceList: [],
        ownTruckNumByType: [],
        natureOfCargo: [],
        typeOfCargo: [],
        porterService: null,
        serviceArea: [],
        crossThaiBorder: [],
        backhaulRequest: [],
        // availableLoadingSystem: [],
        // vehicleEquipment: []
        // // ff
        // typeOfTransport: [],
        // serviceCountry: [],
        // // wh
        // warehouseFacilities: [],
        // warehouseServiceArea: [],
        // warehouseType: [],
        // warehouseSpace: null
        saveDraft: false,
        nid: null
      },
      backhaulRequest: [],
      ownTruckNumByType: [],
      ownTruckTypeError: null,
      companyTypeOptions: [
        { value: 'company-limited', text: 'บริษัทจำกัด' },
        { value: 'public-company-limited', text: 'บริษัท มหาชน จำกัด' },
        { value: 'limited-partnership', text: 'ห้างหุ้นส่วนจำกัด' }
      ],
      company: null,
      reward: [],
      rewardOptions: [],
      standard: [],
      standardOptions: [
        { value: 'หนังสือทะเบียนผู้ประกอบการขนส่งไม่ประจำทาง' },
        { value: 'ตัวแทนออกของรับอนุญาต' },
        { value: 'Q-Mark' },
        { value: 'ISO 9001:2015' },
        { value: 'AEO' },
        { value: 'OHSAS 18001:2007' }
      ],
      network: [],
      networkOptions: [
        { value: 'LTAT สมาคมขนส่งทางบกแห่งประเทศไทย นครสวรรค์' },
        { value: 'IM-EX TA สมาคมขนส่งสินค้าเพื่อการนำเข้าและส่งออก' },
        { value: 'TTLA สมาคมขนส่งสินค้าและโลจิสติกส์ไทย' },
        { value: 'WTA สมาคมรถบรรทุกภาคตะวันตก' },
        { value: 'TTA สมาคมขนส่งสินค้าจังหวัดตาก' },
        { value: 'NTA สมาคมขนส่งสินค้าภาคอีสาน' },
        { value: 'ASLT สมาคมโลจิสติกส์และขนส่งภาคใต้' },
        { value: 'LCTA สมาคมผู้ประกอบการขนส่งแหลมฉบังชลบุรี' },
        { value: 'ASEANLP สมาคมการค้าโลจิสติกส์และผู้ค้าอาเซียน' },
        { value: 'TIFFA สมาคมผู้รับจัดการขนส่งสินค้าระหว่างประเทศ' },
        { value: 'TACBA สมาคมตัวแทนออกของรับอนุญาตไทย' },
        { value: 'TLAPS สมาคมไทยโลจิสติกส์และการผลิต' },
        { value: 'CTAT สมาคมชิปปิ้งแห่งประเทศไทย' },
        { value: 'TEXCA สมาคมขนส่งสินค้าเร่งด่วนไทย' },
        { value: 'TAFA สมาคมตัวแทนขนส่งสินค้าทางอากาศไทย' },
        { value: 'ETA สมาคมขนส่งสินค้าภาคตะวันออก' },
        { value: 'IATA สมาคมขนส่งทางอากาศระหว่างประเทศ' },
        { value: 'FIATA International Federation of Freight Forwarders Associations' },
        { value: 'สภาหอการค้าแห่งประเทศไทย' },
        { value: 'WCA Inter Global' },
        { value: 'สมาคมผู้ประกอบการรถเครน' },
        { value: 'สภาผู้ส่งสินค้าทางเรือแห่งประเทศไทย' },
        { value: 'สมาคมภัตตาคารไทย' },
        { value: 'ชมรมขนส่งสินค้าท่าเรือแหลมฉบังชลบุรี' },
        { value: 'Overseas Project Cargo Association' },
        { value: 'สมาพันธ์เอสเอ็มอีไทย' },
        { value: 'Global Ocean Air Logistics' }
      ],
      businessType: [],
      businessTypeOptions: [
        { value: 'ผู้ผลิต/ผู้จัดจำหน่าย' },
        { value: 'บริษัทขนส่ง' },
        { value: 'ชิปปิ้งและเฟรทฟอร์เวิดเดอร์' },
        { value: 'โกดังสินค้า' }
      ],
      parkingBase: [],
      parkingBaseOptions: [],

      // carrier
      logisticServiceList: [],
      porterServiceOptions: [
        { value: true, text: 'มี' },
        { value: false, text: 'ไม่มี' }
      ],
      natureOfCargo: [],
      natureOfCargoOptions: [
        { value: 'สินค้าทั่วไป สินค้าอุปโภคบริโภค' },
        { value: 'สินค้าส่งเข้า DC' },
        { value: 'ตู้คอนเทนเนอร์ นำเข้า / ส่งออก' },
        { value: 'หิน ดิน ทราย แร่' },
        { value: 'น้ำมัน / สารเคมี / เม็ดพลาสติก / วัตถุอันตราย' },
        { value: 'สินค้าเกษตร' },
        { value: 'ชิ้นส่วนยานยนต์' },
        { value: 'เครื่องใช้ไฟฟ้า / อิเล็กทรอนิกส์' },
        { value: 'สินค้ามูลค่าสูง (เช่น เครื่องประดับ นาฬิกา)' },
        { value: 'สินค้าแช่เย็น / แช่แข็ง' },
        { value: 'สินค้าขนาดใหญ่พิเศษ เครื่องจักร' },
        { value: 'วัสดุก่อสร้าง' },
        { value: 'เครื่องดื่ม' },
        { value: 'รถยนต์' },
        { value: 'ยาและเครื่องสำอางค์' }
      ],
      typeOfCargo: [],
      typeOfCargoOptions: [
        { value: 'Full truck load(ขนส่งเต็มคันรถ)' },
        { value: 'Less than truckload (ขนส่งไม่เต็มคันรถ)' }
      ],
      serviceArea: [],
      serviceAreaOptions: [
        { value: 'ภาคเหนือ' },
        { value: 'ภาคตะวันออกเฉียงเหนือ' },
        { value: 'ภาคกลาง' },
        { value: 'ภาคตะวันออก' },
        { value: 'ภาคตะวันตก' },
        { value: 'ภาคใต้' }
      ],
      crossThaiBorder: [],
      crossThaiBorderOptions: [
        { value: 'พม่า' },
        { value: 'ลาว' },
        { value: 'กัมพูชา' },
        { value: 'มาเลเซีย' }
      ],
      availableLoadingSystem: [],
      vehicleEquipment: [],
      // ff
      typeOfTransport: [],
      typeOfTransportOptions: [
        { value: 'Land' },
        { value: 'Sea' },
        { value: 'Air' }
      ],
      serviceCountry: [],
      // wh
      warehouseFacilities: [],
      warehouseServiceArea: [],
      warehouseType: [],

      truckTypes: [],
      provinceOptions: [],

      truckTypeProfileOptions: [
        { value: '4 ล้อ ตู้ทึบ' },
        { value: '4 ล้อ ตู้เย็น' },
        { value: '4 ล้อ คอกสูง' },
        { value: '4 ล้อ จัมโบ้ ตู้ทึบ' },
        { value: '4 ล้อ จัมโบ้ ตู้เย็น' },
        { value: '4 ล้อ จัมโบ้ คอก' },
        { value: '6 ล้อตู้ทึบ 5.5 เมตร' },
        { value: '6 ล้อตู้ทึบ 6.5 เมตร' },
        { value: '6 ล้อตู้ทึบ 7 เมตร' },
        { value: '6 ล้อคอกสูง 5.5 เมตร' },
        { value: '6 ล้อคอกสูง 6.5 เมตร' },
        { value: '6 ล้อคอกสูง 7 เมตร' },
        { value: '6 ล้อ ตู้เย็น' },
        { value: '6 ล้อพื้นเรียบ' },
        { value: '6 ล้อเครน' },
        { value: '6 ล้อกระบะคาร์โก้' },
        { value: '10 ล้อตู้ทึบ' },
        { value: '10 ล้อคอกสูง' },
        { value: '10 ล้อคอกสูงดัมพ์' },
        { value: '10 ล้อคอกตํ่า' },
        { value: '10 ล้อคอกตํ่าดัมพ์' },
        { value: '10 ล้อ ตู้เย็น' },
        { value: '10 ล้อพื้นเรียบ' },
        { value: '10 ล้อเครน' },
        { value: '10 ล้อแทงเกอร์' },
        { value: '10 ล้อกระบะคาร์โก้' },
        { value: 'พ่วงคอกตํ่า' },
        { value: 'พ่วงคอกตํ่าดัมพ์' },
        { value: 'พ่วงคอกสูง' },
        { value: 'พ่วงคอกสูงดัมพ์' },
        { value: 'พ่วงตู้ทึบ' },
        { value: 'พ่วงพื้นเรียบ' },
        { value: 'หัวลาก' },
        { value: 'เทรลเลอร์หางก้าง' },
        { value: 'เทรลเลอร์หางพื้นเรียบ' },
        { value: 'เทรลเลอร์หางพื้นเรียบชานต่ำ (Low Bed)' },
        { value: 'เทรลเลอร์หางม่านข้าง' },
        { value: 'เทรลเลอร์หางคอก' },
        { value: 'เทรลเลอร์หางคอกดั๊มพ์' },
        { value: 'เทรลเลอร์หางตู้เย็น 40ft' },
        { value: 'เทรลเลอร์หางตู้เย็น 20ft' },
        { value: 'เทรลเลอร์หางแทงเกอร์' }
        // { value: 'เทรลเลอร์หางตู้คอนเทนเนอร์ 40ft' },
        // { value: 'เทรลเลอร์หางตู้คอนเทนเนอร์ 20ft' }
        // { value: 'หางคอก' },
        // { value: 'หางคอกดั๊มพ์' },
        // { value: 'หางตู้คอนเทนเนอร์ 20ft' },
        // { value: 'หางตู้คอนเทนเนอร์ 40ft' },
        // { value: 'หางพื้นเรียบ' },
        // { value: 'หางพื้นเรียบ low bed' },
        // { value: 'หางม่านข้าง' },
        // { value: 'หางก้าง' },
        // { value: 'หางแทงเกอร์' }
      ],

      truckTypeSelected: [],

      foundingYear: null,

      loadOk: false,
      carrierStatus: null,

      profileUrl: null
    }
  },
  validations: {
    form: {
      companyName: {
        required
      },
      // phoneNumber: {
      //   required,
      //   thPhoneNumber
      // },
      email: {
        required
      },
      // profileUrl: {
      //   required
      // },
      companyType: {
        required
      },
      tel: {
        // thPhoneNumber
        required
      },
      website: {

      },
      employeeNum: {
        required,
        numeric
      },
      // registeredCapital: {
      //   decimal
      // },
      // lastYearRevenue: {
      //   decimal
      // },
      porterService: {
        required: requiredIf(function () {
          return this.textObjToArr(this.businessType).includes('บริษัทขนส่ง')
        })
      },
      typeOfCargo: {
        required: requiredIf(function () {
          return this.textObjToArr(this.businessType).includes('บริษัทขนส่ง')
        })
      },
      crossThaiBorder: {
        // required: requiredIf(function () {
        //   return this.textObjToArr(this.businessType).includes('บริษัทขนส่ง')
        // })
      },
      natureOfCargo: {
        required: requiredIf(function () {
          return this.textObjToArr(this.businessType).includes('บริษัทขนส่ง')
        })
      },
      // warehouseSpace: {
      //   decimal
      // },
      companyHQProvince: {
        required
      },
      address: {
        required
      },
      contactPersion: {
        required
      },
      nid: {
        required,
        numeric,
        minLength: minLength(13),
        maxLength: maxLength(13)
      }
    },
    foundingYear: {
      required,
      numeric,
      between: between(1000, 3000)
    },
    standard: {

    },
    reward: {

    },
    network: {

    },
    businessType: {
      required
    },
    serviceArea: {
      required: requiredIf(function () {
        return this.textObjToArr(this.businessType).includes('บริษัทขนส่ง')
      })
    },
    parkingBase: {
      required: requiredIf(function () {
        return this.textObjToArr(this.businessType).includes('บริษัทขนส่ง')
      })
    },
    backhaulRequest: {
      $each: {
        from: {
          required
        },
        to: {
          required
        },
        truckType: {
          required
        }
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      Window.Event.$emit('showModalLoading')
      try {
        var appInfo = new AppInfo()
        var province = await appInfo.getAllProvince()
        this.provinceOptions = province.data
        // prepare province for multiselect
        this.parkingBaseOptions = this.provinceOptions.map((x) => {
          return { value: x.name }
        })

        // load trucktype
        var truckType = new TruckType()
        var types = await truckType.getAllTruckType()
        if (types.code === 1) {
          this.truckTypes = types.data
          // console.log(this.truckTypes)
        }

        var profile = new Profile()
        var loaded = await profile.getPrivateProfileById(this.$cookies.get('companyId'))
        // console.log(loaded)
        this.form.companyName = loaded.data.name
        this.form.email = loaded.data.email
        this.form.companyType = loaded.data.type
        this.form.profileUrl = loaded.data.profileUrl ? loaded.data.profileUrl : randomstring.generate()
        this.form.tel = loaded.data.tel
        this.form.contactPersion = loaded.data.contactPersion
        this.form.website = loaded.data.website
        this.foundingYear = loaded.data.foundingYear ? parseInt(this.$moment(loaded.data.foundingYear).year()) + 543 : null
        this.form.employeeNum = loaded.data.employeeNum
        this.form.reward = loaded.data.reward ? this.ArrToTextObj(loaded.data.reward) : []
        this.form.standard = loaded.data.standard ? this.ArrToTextObj(loaded.data.standard) : []
        this.form.network = loaded.data.network ? this.ArrToTextObj(loaded.data.network) : []
        this.form.businessType = loaded.data.businessType ? this.ArrToTextObj(loaded.data.businessType) : []
        this.form.parkingBase = loaded.data.parkingBase ? this.ArrToTextObj(loaded.data.parkingBase) : []
        this.form.companyHQProvince = loaded.data.companyHQProvince
        this.form.ownTruckNumByType = loaded.data.ownTruckNumByType ? loaded.data.ownTruckNumByType : []
        this.form.natureOfCargo = loaded.data.natureOfCargo
        this.form.typeOfCargo = loaded.data.typeOfCargo
        this.form.porterService = loaded.data.porterService
        this.form.serviceArea = loaded.data.serviceArea ? this.ArrToTextObj(loaded.data.serviceArea) : []
        this.form.crossThaiBorder = loaded.data.crossThaiBorder
        this.form.saveDraft = loaded.data.saveDraft
        this.form.nid = loaded.data.nid

        this.backhaulRequest = loaded.data.backhaulRequest ? loaded.data.backhaulRequest.map((item) => {
          item.truckType = item.truckType.map((x) => {
            return { value: x }
          })
          return item
        }) : []

        // load trucktype to from

        this.form.ownTruckNumByType.forEach((item) => {
          this.ownTruckNumByType[item.name] = item.value
          // if (item.name.includes('4 ล้อ') && !this.truckTypeSelected.includes('4 ล้อ')) {
          //   if (!this.truckTypeSelected.includes('4ล้อ')) {
          //     this.truckTypeSelected.push('4ล้อ')
          //   }
          // }
          // if (item.name.includes('6 ล้อ') && !this.truckTypeSelected.includes('6 ล้อ')) {
          //   if (!this.truckTypeSelected.includes('6ล้อ')) {
          //     this.truckTypeSelected.push('6ล้อ')
          //   }
          // }
          // if (item.name.includes('10 ล้อ') && !this.truckTypeSelected.includes('10 ล้อ')) {
          //   if (!this.truckTypeSelected.includes('10ล้อ')) {
          //     this.truckTypeSelected.push('10ล้อ')
          //   }
          // }
          // if (item.name.includes('พ่วง') && !this.truckTypeSelected.includes('รถพ่วง')) {
          //   if (!this.truckTypeSelected.includes('รถพ่วง')) {
          //     this.truckTypeSelected.push('รถพ่วง')
          //   }
          // }
          // if ((item.name.includes('เทรลเลอร์') || item.name.includes('หัวลาก')) && !this.truckTypeSelected.includes('เทรลเลอร์')) {
          //   if (!this.truckTypeSelected.includes('เทรลเลอร์')) {
          //     this.truckTypeSelected.push('เทรลเลอร์')
          //   }
          // }
        })

        this.form.address = loaded.data.address

        // availableLoadingSystem: [],
        // vehicleEquipment: []
        // // ff
        // typeOfTransport: [],
        // serviceCountry: [],
        // // wh
        // warehouseFacilities: [],
        // warehouseServiceArea: [],
        // warehouseType: [],
        // warehouseSpace: null

        this.reward = this.form.reward
        this.standard = this.form.standard
        this.network = this.form.network
        this.businessType = this.form.businessType
        this.parkingBase = this.form.parkingBase
        // this.natureOfCargo = this.form.natureOfCargo
        // this.typeOfCargo = this.form.typeOfCargo
        this.serviceArea = this.form.serviceArea
        // this.crossThaiBorder = this.form.crossThaiBorder

        // console.log(this.form)

        // load status
        this.carrierStatus = loaded.data.carrierStatus
        // load profileUrl for preview button
        this.profileUrl = loaded.data.profileUrl

        this.loadOk = true

        this.$v.$touch()
        this.onTruckNumChange()
      } catch (error) {
        console.log(error)
        await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
      }

      Window.Event.$emit('closeModalLoading')
    },
    goBack () {
      this.$router.back()
    },
    async save (draft) {
      if (draft) {
        this.form.saveDraft = true
      }

      this.$v.$touch()

      // check trucknum valid
      this.onTruckNumChange()

      if (!draft) {
        if (this.$v.$anyError || (this.textObjToArr(this.businessType).includes('บริษัทขนส่ง') && this.ownTruckTypeError === true)) {
          this.makeToast('warning', 'คำเตือน', 'กรุณาระบุข้อมูลสำคัญให้ครบถ้วน')
          return
        }
      }

      if (!draft) {
        this.form.saveDraft = false
      }

      Window.Event.$emit('showModalLoading')

      // prepare data for save
      this.form.name = this.form.companyName
      this.form.type = this.form.companyType
      this.form.reward = this.textObjToArr(this.reward)
      this.form.standard = this.textObjToArr(this.standard)
      this.form.network = this.textObjToArr(this.network)
      this.form.businessType = this.textObjToArr(this.businessType)
      this.form.parkingBase = this.textObjToArr(this.parkingBase)
      this.form.logisticServiceList = this.textObjToArr(this.logisticServiceList)
      // this.form.natureOfCargo = this.textObjToArr(this.natureOfCargo)
      // this.form.typeOfCargo = this.textObjToArr(this.typeOfCargo)
      this.form.serviceArea = this.textObjToArr(this.serviceArea)
      // this.form.crossThaiBorder = this.textObjToArr(this.crossThaiBorder)

      this.form.foundingYear = this.foundingYear ? this.$moment((parseInt(this.foundingYear) - 543) + '-01-01') : null

      let temp = JSON.parse(JSON.stringify(this.backhaulRequest))

      this.form.backhaulRequest = temp.map((item) => {
        item.truckType = item.truckType.map((x) => {
          return x.value
        })
        return item
      })

      this.form.ownTruckNumByType = []
      for (const [key, value] of Object.entries(this.ownTruckNumByType)) {
        if (value > 0) {
          this.form.ownTruckNumByType.push({
            name: key,
            value: value
          })
        }
      }

      // console.log(this.form)
      let profile = new Profile()

      try {
        let updated = await profile.updateCompanyProfile(this.form)
        if (updated.code === 1) {
          if (draft) {
            await this.$bvModal.msgBoxOk('บันทึกร่างสำเร็จ', this.$getConst('okModalClass'))
            Window.Event.$emit('closeModalLoading')
            this.init()
          } else {
            let msgText
            if (updated.data.shipperStatus) {
              msgText = 'บันทึกข้อมูลเข้าสู่ระบบสำเร็จ'
            } else {
              msgText = 'กรุณารอเจ้าหน้าที่ติดต่อกลับเพื่อยืนยันตัวตนภายใน 1-2 วัน'
            }
            await this.$bvModal.msgBoxOk(msgText, this.$getConst('okModalClass'))
            Window.Event.$emit('closeModalLoading')
            this.$router.push({
              name: 'ค้นหาบริษัท'
            })
          }
        } else {
          await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
        }
      } catch (error) {
        console.log(error)
        await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
      }

      Window.Event.$emit('closeModalLoading')
    },
    addListReward (newTag) {
      const tag = {
        name: newTag
      }
      this.rewardOptions.push(tag)
      this.reward.push(tag)
    },
    textObjToArr (obj) {
      var out = obj.map(x => x.value)
      return out
    },
    ArrToTextObj (arr) {
      if (arr) {
        var out = arr.map((x) => {
          return { value: x }
        })

        return out
      } else {
        return []
      }
    },
    appendBackhaul () {
      this.backhaulRequest.push({
        from: null,
        to: null,
        truckType: []
      })
    },
    removeBackhaul (index) {
      this.$delete(this.backhaulRequest, index)
    },
    appendOwnTruck () {
      this.form.ownTruckNumByType.push({
        name: null,
        value: null
      })
    },
    deleteOwnTruck (index) {
      this.$delete(this.form.ownTruckNumByType, index)
    },
    makeToast (variant = 'success', title = '', content = '') {
      this.$bvToast.toast(content, {
        title: title,
        variant: variant,
        solid: true
      })
    },
    onTruckNumChange () {
      this.ownTruckTypeError = true
      for (const [key, value] of Object.entries(this.ownTruckNumByType)) {
        if (value > 0) {
          this.ownTruckTypeError = false
        }
      }
    }
  },
  computed: {
    showCarrier () {
      if (this.businessType.length > 0) {
        let show = false
        this.businessType.forEach((value, index) => {
          if (value.value === 'บริษัทขนส่ง') {
            show = true
          }
        })
        return show
      } else {
        return false
      }
    }
  },
  watch: {
    truckTypeSelected () {
      let ownTruckTemp = []

      if (this.truckTypeSelected.includes('4ล้อ')) {
        for (const [key, value] of Object.entries(this.ownTruckNumByType)) {
          if (key.includes('4 ล้อ')) {
            ownTruckTemp[key] = parseInt(value)
          }
        }
      }
      if (this.truckTypeSelected.includes('6ล้อ')) {
        for (const [key, value] of Object.entries(this.ownTruckNumByType)) {
          if (key.includes('6 ล้อ')) {
            ownTruckTemp[key] = parseInt(value)
          }
        }
      }
      if (this.truckTypeSelected.includes('10ล้อ')) {
        for (const [key, value] of Object.entries(this.ownTruckNumByType)) {
          if (key.includes('10 ล้อ')) {
            ownTruckTemp[key] = parseInt(value)
          }
        }
      }
      if (this.truckTypeSelected.includes('รถพ่วง')) {
        for (const [key, value] of Object.entries(this.ownTruckNumByType)) {
          if (key.includes('พ่วง')) {
            ownTruckTemp[key] = parseInt(value)
          }
        }
      }
      if (this.truckTypeSelected.includes('เทรลเลอร์')) {
        for (const [key, value] of Object.entries(this.ownTruckNumByType)) {
          if (key.includes('เทรลเลอร์') || key.includes('หัวลาก')) {
            ownTruckTemp[key] = parseInt(value)
          }
        }
      }

      // console.log(ownTruckTemp)
      this.ownTruckNumByType = ownTruckTemp
    }
    // ownTruckNumByType () {
    //   this.ownTruckTypeError = false
    //   for (const [key, value] of Object.entries(this.ownTruckNumByType)) {
    //     if (value > 0) {
    //       this.ownTruckTypeError = false
    //     }
    //   }
    // }

  }
}
</script>
